// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__8Texk","addBtnContainer":"AddDetails_addBtnContainer__YoFxd"};